import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';
import { HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  idEmpresa: string;
  idUsuario: string;
  infoUsuario: any;
  idInstituto: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    this.idInstituto = this.authService.getInstituto();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idEmpresa = infoUsu.empresaId;
    this.infoUsuario = this.authService.getInfoUsuario();
    console.log("Id user"+this.idUsuario);
  }
  enviarCodigo(datos,idUsuario){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.enviarCodigo+idUsuario ,datos);
  }
  buscarCorreo(datos){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.buscarCorreo ,datos);
  }
  searchToken(token){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.buscarToken + token);
  }


  getUsuariosEmpresas(nomEmpresa:any,instituto:any){

    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getUsuariosEmpresas+nomEmpresa+"/"+instituto+"/"+1);  
  }

  actualizarUsuario(datos){
    console.log(datos);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.updateUser_ ,datos);
  }

  actualizaUsuariosEmpresas(iduser:any,datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.actualizaInfoUsuarioEmpresa+iduser,datos);
  }


  getInfoEmpresa(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.empresas + this.idEmpresa);
  }










}
